Object.defineProperty(exports, "createPolyfillPlugins", {
  get: () => require("./polyfills.cjs"),
});
